import { format } from 'date-fns';
import { Container, Content, FirstText, SecondText } from './styles';

const CustomTooltip = ({ payload }) => {
  const currentPayload = payload[0]?.payload;

  function formatDate(text) {
    const date = new Date(text);
    return format(date, "dd/MM/yyyy 'às' HH:mm");
  }

  if (payload.length > 0) {
    return (
      <Container>
        <Content>
          <div>
            <FirstText>Registro:</FirstText>
            <SecondText>
              {formatDate(currentPayload.lastRegistrationDate)}
            </SecondText>
          </div>
          <div>
            <FirstText>Temperatura:</FirstText>
            <SecondText>{currentPayload.temperature}°C</SecondText>
          </div>
        </Content>
      </Container>
    );
  }

  return null;
};

export default CustomTooltip;
